import axios from "axios";
import { reviewSubmission } from "../containers/CarFinance/mapper";
import packageJson from "../../package.json";
import { normalizeUkMobile } from "../utils/utils";
const websiteVersion = packageJson.version;

const pages = {
  IntroCheckDetails: 0,
  NewClaimantDetails: 0,
  ContactDetails: 0,
  AddressDetails: 0,
  AddressLookup: 0,
  ConfirmDetails: 0,
  Signature: 0,
  Summary: 0,
  CreditCheckSuccess: 0,
  RequestFinanceLender: 0,
  Success: 0,
  PostSuccess: 0,
  NoClaim: 0,
  Error: 0,
};

// Removed hardcoded lender and carMakes arrays - now using dynamic API calls

export const claimValue = 1500;

Object.keys(pages).forEach((key, index) => (pages[key] = index));
export const formPages = pages;

export const baseUrl = "";

// export const CRM_SUBMIT_ENDPOINT = () => {
//   return `${baseUrl}/api/create-case`;
// };

export const ADDRESS_ENDPOINT = async (
  compensate,
  query,
  containerId = null,
) => {
  try {
    const response = await axios.post(`${baseUrl}/api/public/address/find`, {
      query: query,
      container: containerId,
    });

    // const clientIp = response.data?.response?.client_ip || null;
    // CALL IP ENDPOINT (GET + headers)
    // const ipResponse = await axios.get(`${baseUrl}/api/1.0/ip_address`, {
    //   headers: {
    //     accept: "application/json",
    //     "x-api-key": "w439RKAhrjMLBbYLgqp3JG5HPK9BjbCcPhW5ISWnUZQ=",
    //   },
    // });
    // STORE IP INSIDE compensate
    // if (ipResponse) {
    //   compensate.websiteAquisitionIpAddress = ipResponse.data.address;
    // }

    // const clientIp = response.data?.response?.client_ip || null;
    // if (compensate && clientIp) {
    //   compensate.ipAddress = clientIp;
    // }

    const items = response.data?.response?.data?.Items || [];

    // If single non-Address result, auto-drill down
    if (items?.length === 1 && items[0].Type !== "Address") {
      const refinedResponse = await axios.post(
        `${baseUrl}/api/public/address/find`,
        {
          query: items[0].Text,
          container: items[0].Id,
        },
      );
      // const refinedClientIp = refinedResponse.data?.response?.client_ip || null;
      // if (compensate && refinedClientIp) {
      //   compensate.ipAddress = refinedClientIp;
      // }
      return refinedResponse.data?.response?.data?.Items || [];
    }
    return items;
  } catch (error) {
    console.error("Error finding addresses:", error);
    throw error;
  }
};

export const ADDRESS_RETRIEVE = async (id) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/public/address/retrieve`,
      {
        id: id,
      },
    );
    return response.data.response.data.Items[0];
  } catch (error) {
    console.error("Error finding addresses:", error);
    throw error;
  }
};

// export const CREDIT_CHECK = () => {
//   return `${baseUrl}/api/credit-check`;
// };

export const CLIENT_DETAILS = async (uid, marketingChannel = null) => {
  try {
    const response = await axios.post(`${baseUrl}/api/public/client/details`, {
      uid: uid,
      marketing_channel: marketingChannel,
    });
    return response.data.response.data;
  } catch (error) {
    console.error("Error fetching client details", error);
    throw error;
  }
};

export const VERIFY_CLIENT = async (uid, firstName, surname) => {
  try {
    const response = await axios.post(`${baseUrl}/api/public/client/verify`, {
      uid,
      first_name: firstName,
      surname,
    });
    if (response.data.error) return null;
    return response.data.response.data;
  } catch (error) {
    console.error("Error verifying client", error);
    throw error;
  }
};

export const VERIFY_CLIENT_TOKEN = async (uid, verificationToken) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/public/client/verify-token`,
      {
        uid,
        verification_token: verificationToken,
      },
    );
    if (response.data.error) return null;
    return response.data.response.data;
  } catch (error) {
    console.error("Error validating client verification token", error);
    throw error;
  }
};


export const VALIDATE_EMAIL = async (email) => {
  try {
    const response = await axios.post(`${baseUrl}/api/public/email/validate`, {
      email: email?.trim(),
    });
    return {
      isValid: (response.data.message?.response || response.data.response) === "Valid Email Address",
      domainDoesNotExist: false,
    };
  } catch (error) {
    console.error("Error validating email", error);
    // Check if it's a "Domain does not exist" error
    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.message ||
      "";
    if (errorMessage.includes("Domain does not exist")) {
      return { isValid: false, domainDoesNotExist: true };
    }
    throw error;
  }
};

// Utility function to convert text to proper case
const toProperCase = (text) => {
  if (!text) return text;

  // Convert to lowercase first, then capitalize each word
  return text.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());
};

export const MAKES_LIST = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/public/makes`);
    const makeList = response.data.response.data;
    return makeList?.map((item) => ({
      text: toProperCase(item),
      value: item, // Keep original value for API consistency
    }));
  } catch (error) {
    console.error("Error fetching make list", error);
    throw error;
  }
};

export const LENDER_LIST = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/public/lenders`);
    const lenderList = response.data.response.data;
    return lenderList?.map((item) => ({
      text: toProperCase(item),
      value: item, // Keep original value for API consistency
    }));
  } catch (error) {
    console.error("Error fetching lender list", error);
    throw error;
  }
};

export const HTML_TO_PDF = async (content) => {
  try {
    const response = await axios.post(`${baseUrl}/api/html2pdf`, {
      content: content,
    });
    const html2Pdf = response.data.message.response.data;
    return html2Pdf;
  } catch (error) {
    console.error("Error fetching HTML to PDF", error);
    throw error;
  }
};

export const CUSTOMER_REVIEW = async (compensate, review) => {
  try {
    const response = await axios.post(
      "https://datastore.tanantech.co.uk/1.0/data",
      reviewSubmission(compensate, review),
    );
    console.log(response.data);
  } catch (error) {
    console.error("Error sending customer review");
    throw error;
  }
};

export const DVLA_CHECK = () => {
  return `${baseUrl}/api/public/dvla-check`;
};

export const EMAIL_COMMS = () => {
  return `${baseUrl}/api/email-comms`;
};

export const KOUNT_NEW_ACCOUNT_OPENING = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/public/kount/new-account-opening`,
      payload,
    );
    return response.data.response;
  } catch (error) {
    console.error("Error creating KOUNT new account opening:", error);
    throw error;
  }
};

// Helper function to check if email is a testing email
export const isTestingEmail = (email) => {
  if (!email) return false;
  const normalizedEmail = email.trim().toLowerCase();
  const testingDomains = [
    "@tanantech.co.uk",
    "@lloydjames.com",
    "@yourclaimmatters.co.uk",
    "@mylawmatters.co.uk",
    "@legal-ventures.co.uk",
  ];
  return testingDomains.some((domain) => normalizedEmail.endsWith(domain));
};

const sanitizeAddressForStorage = (address) => {
  if (Array.isArray(address)) {
    return address.map(sanitizeAddressForStorage);
  }
  if (!address || typeof address !== "object") {
    return address;
  }

  const { Text: _text, ...addressForStorage } = address;
  return addressForStorage;
};

const prepareClientDataForDb = (clientData) => {
  const {
    emailRoute,
    currentPostcode: _currentPostcode,
    currentAddressSelected: _currentAddressSelected,
    currentAddressData: _currentAddressData,
    previousAddressPostCode: _previousAddressPostCode,
    previousAddressData: _previousAddressData,
    previousAddressSelected: _previousAddressSelected,
    previousPreviousAddressPostCode: _previousPreviousAddressPostCode,
    previousPreviousAddressData: _previousPreviousAddressData,
    previousPreviousAddressSelected: _previousPreviousAddressSelected,
    isDeeplink: _isDeeplink,
    ...clientDataForDb
  } = clientData ?? {};

  if (clientDataForDb.currentAddress !== undefined) {
    clientDataForDb.currentAddress = sanitizeAddressForStorage(
      clientDataForDb.currentAddress,
    );
  }
  if (clientDataForDb.previousAddress !== undefined) {
    clientDataForDb.previousAddress = sanitizeAddressForStorage(
      clientDataForDb.previousAddress,
    );
  }

  return { emailRoute, clientDataForDb };
};

// Store client data only (without email)
export const STORE_CLIENT_DATA_ONLY = async (clientData) => {
  try {
    // Check if this is a testing email
    const { clientDataForDb } = prepareClientDataForDb(clientData);
    const email = clientDataForDb?.email?.trim();
    const testing = isTestingEmail(email);
    const mobile = normalizeUkMobile(clientDataForDb?.mobile);

    const response = await axios.post(`${baseUrl}/api/public/client/submit`, {
      ...clientDataForDb,
      ...(clientDataForDb?.mobile !== undefined && { mobile }),
      testing,
      websiteVersion,
    });
    return response.data;
  } catch (error) {
    console.error("Error storing client data:", error);
    throw error;
  }
};


// Store client data AND send email
export const STORE_CLIENT_DATA = async (clientData) => {
  try {
    // Import brand detection dynamically to avoid circular dependencies
    const { detectBrand } = await import("../utils/brandDetection");
    const brand = detectBrand();

    // Check if this is a testing email
    const { emailRoute, clientDataForDb } = prepareClientDataForDb(clientData);
    const mobile = normalizeUkMobile(clientDataForDb.mobile);
    if (clientDataForDb.mobile !== undefined) {
      clientDataForDb.mobile = mobile;
    }
    if (clientDataForDb.kountRequest?.mobileNumber !== undefined) {
      clientDataForDb.kountRequest = {
        ...clientDataForDb.kountRequest,
        mobileNumber: normalizeUkMobile(clientDataForDb.kountRequest.mobileNumber),
      };
    }
    if (clientDataForDb.kountResponse?.kountMobileNumberUsed !== undefined) {
      clientDataForDb.kountResponse = {
        ...clientDataForDb.kountResponse,
        kountMobileNumberUsed: normalizeUkMobile(
          clientDataForDb.kountResponse.kountMobileNumberUsed,
        ),
      };
    }
    const email = clientDataForDb?.email?.trim();
    const testing = isTestingEmail(email);

    // 1) Store client data with testing flag if applicable
    const response = await axios.post(`${baseUrl}/api/public/client/submit`, {
      ...clientDataForDb,
      testing,
      websiteVersion,
    });

    // 2) Fire email request but do not change return type
    // Send email to comms API
    if (email) {
      // only send client firstname
      const client1_firstname = clientData?.firstName?.trim();

      // Always use the uniqueID returned by the backend
      const uniqueID = response.data?.uniqueID;

      // log to console so you can see it
      // console.log("email going to comms API:", email);
      // console.log("client1_firstname going to comms API:", client1_firstname);
      // console.log("uniqueID going to comms API:", uniqueID);
      // console.log("brand_id going to comms API:", brand.id);
      try {
        await axios.post(
          `${baseUrl}/api/public/comms/email`,
          {
            email,
            extra_fields: {
              client1_firstname,
              uniqueID,
              brand_id: brand.id,
              ...(emailRoute && { email_route: emailRoute }),
            },
          },
          {
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );
        // console.log("Email sent successfully from Signature page submit");
      } catch (emailErr) {
        console.error("Error sending email:", emailErr);
        // don't throw so return type stays same
      }
    }
    // return type unchanged
    return response.data;
  } catch (error) {
    console.error("Error storing client data:", error);
    throw error;
  }
};
